import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { UserBonus, WageringConditionBonus } from 'config/types/bonus/userBonus'
import { Trans } from 'react-i18next'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { BonusContentFieldTitle, BonusContentGridSystem } from '../styled'

const BonusContentAmount: React.FC<{ bonus: UserBonus; title?: string } & BoxProps> = ({ bonus, title, ...props }) => {
  return (
    bonus instanceof WageringConditionBonus && (
      <BonusContentGridSystem {...props}>
        <BonusContentFieldTitle>{title ? <Trans>{title}</Trans> : <Trans>Your bonus</Trans>}</BonusContentFieldTitle>

        <Flex alignItems="center">
          <>
            <TokenLogo token={bonus.bonusAmount.token} size={16} />
            <Text fontWeight="600" fontSize="14px" ml="4px" lineHeight="normal">
              {getFullDisplayBalance(bonus.bonusAmount.amount, 0, 5)}
            </Text>
            <Text fontWeight="600" color="textAlt1" fontSize="14px" ml="4px" lineHeight="normal">
              {bonus.bonusAmount?.token?.name}
            </Text>
          </>
        </Flex>
      </BonusContentGridSystem>
    )
  )
}

export default BonusContentAmount
